
export default {
  data() {
    return {
      'open': false,
    }
  },
  computed: {
    url() {
      return window.location.href
    }
  }
}
